module.exports = __webpack_public_path__ + "img/trans-bg.15dc098e.jpg";